export default "__VITE_ASSET__DR2Q92tX__"